import { render } from "./ShowPhaseNoteModal.vue?vue&type=template&id=1b0b167f&scoped=true&ts=true"
import script from "./ShowPhaseNoteModal.vue?vue&type=script&lang=ts"
export * from "./ShowPhaseNoteModal.vue?vue&type=script&lang=ts"

import "./ShowPhaseNoteModal.vue?vue&type=style&index=0&id=1b0b167f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0b167f"]])

export default __exports__